import React from "react";
import { AboutContent } from "../../components/AboutContent/AboutContent";

const About: React.FC = () => {
  return (
    <>
      <AboutContent />
    </>
  );
};
export default About;
